var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -11.8991,
    x2: 40.2992,
    y1: 48.6943,
    y2: -8.3222
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1625,
    stopColor: "#2391c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4043,
    stopColor: "#378bbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#7f6cb1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 43.5526,
    x2: 95.9878,
    y1: 149.1739,
    y2: 94.8756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c93c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#2d8ebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6399,
    stopColor: "#587eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#7f6cb1"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 3.2398,
    x2: 92.4815,
    y1: 95.2486,
    y2: 2.1156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c757a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04551384,
    stopColor: "#ca5a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2413,
    stopColor: "#d66779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#e17357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6004,
    stopColor: "#e97c3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7556,
    stopColor: "#ef8324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8879,
    stopColor: "#f28817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9819,
    stopColor: "#f48912"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h65.4l-65.4 64.4z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128 128-63.4-65.4-64.6 65.4z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 128 128-128h-63.4l-64.6 63.7z",
    fill: "url(#c)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.26e0dcb3c5770ff6d8dc491c17849d28.svg";
export { ForwardRef as ReactComponent };